import { jsx } from 'react/jsx-runtime';

/** ![link2OffIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48cGF0aCBkPSJNOSAxN0g3QTUgNSAwIDAgMSA3IDdNMTUgN2gyYTUgNSAwIDAgMSA0IDhNOCAxMmg0TTIgMmwyMCAyMCIvPjwvc3ZnPg==) */
const link2OffIcon = /*#__PURE__*/jsx("path", {
  d: "M9 17H7A5 5 0 0 1 7 7M15 7h2a5 5 0 0 1 4 8M8 12h4M2 2l20 20"
});

export { link2OffIcon };
